import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getAuditLogsEndpoint } from '../../../common/endpoints';

export const getAuditLogsData = createApi(getAuditLogsEndpoint, 'GET');

const GetAuditLogs = createSlice({
  name: 'GetAllSourcePriceMemo',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAuditLogsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAuditLogsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAuditLogsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAuditLogs.reducer;